export const isAppointmentsPage = () => {
  return window.location.pathname.includes('/schedule');
};
